var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('polygon',{attrs:{"points":"0 11 2 9 7 14 18 3 20 5 7 18"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }